/**
 * Operator for OCPP logs: prefer global (header) selection, then charger payload fields.
 * Supports both API spellings: operatorId, operatorID.
 */
export function resolveOcppLogsOperatorId(globalOperatorId, chargerEntity) {
  if (globalOperatorId != null && String(globalOperatorId).trim() !== '') {
    return String(globalOperatorId).trim();
  }
  if (!chargerEntity || typeof chargerEntity !== 'object') {
    return undefined;
  }
  const fromCharger =
    chargerEntity.operatorId ?? chargerEntity.operatorID;
  if (fromCharger != null && String(fromCharger).trim() !== '') {
    return String(fromCharger).trim();
  }
  return undefined;
}

/**
 * Query string for /dashboard/OCPP-logs so links work in new tabs and on refresh.
 * Uses ChargerId + chargerName (legacy) and operatorId for archived APIs / charger list.
 */
export function buildOcppLogsSearch({ chargerId, chargerName, operatorId }) {
  const params = new URLSearchParams();
  if (chargerId != null && chargerId !== '') {
    params.set('ChargerId', String(chargerId));
  }
  if (chargerName != null && String(chargerName).trim() !== '') {
    params.set('chargerName', String(chargerName).trim());
  }
  if (operatorId != null && operatorId !== '') {
    params.set('operatorId', String(operatorId));
  }
  const q = params.toString();
  return q ? `?${q}` : '';
}
